////// Packages //////////////////
import React, {FC} from 'react';
import classNames from 'classnames';

////// Local Components //////////

////// Global Components /////////

////// CommonJS Helpers //////////

////// Custom Hooks //////////////

////// Thunks ////////////////////

export interface Props {
  image?: string;
  overlay?: 'primary' | 'info' | 'success' | 'warning' | 'danger' | '0' | '1' | '2';
  position?: string | {x: string; y: string;};
  video?: string[];
  className?: string;
  style?: React.CSSProperties;
}
const Background: FC<Props> = ({ image, overlay, position, video, className, style }) => {
  const bgStyle = { backgroundImage: `url(${image})`, ...style } as React.CSSProperties;
  if (typeof position === 'string') {
    bgStyle.backgroundPosition = position;
  } else if (typeof position === 'object') {
    position.x && (bgStyle.backgroundPositionX = position.x);
    position.y && (bgStyle.backgroundPositionY = position.y);
  }

  return (
    <div
      className={classNames(
        'bg-holder',
        { overlay: overlay, [`overlay-${overlay}`]: typeof overlay === 'string' },
        className
      )}
      style={bgStyle}
    >
      {video && (
        <video className="bg-video" autoPlay loop muted playsInline>
          {video.map((src, index) => (
            <source key={index} src={src} type={`video/${src.split('.').pop()}`} />
          ))}
        </video>
      )}
    </div>
  );
};


export default Background;
